export var CheckoutSteps;
(function (CheckoutSteps) {
    CheckoutSteps["CART"] = "cart";
    CheckoutSteps["SHIPPING_DETAILS"] = "shipping-details";
    CheckoutSteps["ORDER_REVIEW"] = "order-review";
    CheckoutSteps["PAYMENT"] = "payment";
    CheckoutSteps["SUCCESS"] = "success";
    CheckoutSteps["THANK_YOU"] = "thank-you";
})(CheckoutSteps || (CheckoutSteps = {}));
export const CHECKOUT_PAGE_ORDER = {
    shoppingCart: 1,
    shippingDetails: 2,
    orderReview: 3,
    payAndPlaceOrder: 4,
    successPage: 5,
    thankYou: 6,
};
export const EMAIL_PLACEHOLDER = '{email}';
export const CheckoutStepsHashes = [
    CheckoutSteps.CART,
    CheckoutSteps.SHIPPING_DETAILS,
    CheckoutSteps.ORDER_REVIEW,
    CheckoutSteps.PAYMENT,
    CheckoutSteps.SUCCESS,
    CheckoutSteps.THANK_YOU,
].map((step) => `#${step}`);
export const IS_CREATE_ACCOUNT_FIELD = 'isCreateAccount';
export const ITALY_COUNTRY_CODE = 'it';
export const ADYEN = 'adyen';
export const SANTANDER = 'santander';
export const PAYEVER = 'payever';
export const CART_ID = 'cartId';
export const CYCLESCHEME = 'cyclescheme';
export const TERMINAL_PAYMENT = 'terminalPayment';
export var PaymentMethodOverrideKeys;
(function (PaymentMethodOverrideKeys) {
    PaymentMethodOverrideKeys["Card"] = "card";
})(PaymentMethodOverrideKeys || (PaymentMethodOverrideKeys = {}));
export var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["KlarnaPayNow"] = "klarna_paynow";
    PaymentMethod["KlarnaAccount"] = "klarna_account";
    PaymentMethod["KlarnaPayLater"] = "klarna";
    PaymentMethod["Card"] = "scheme";
    // this methods not actually used (for now):
    PaymentMethod["Ideal"] = "ideal";
    PaymentMethod["PayPal"] = "paypal";
    PaymentMethod["GooglePay"] = "googlepay";
})(PaymentMethod || (PaymentMethod = {}));
export const PaymentMethodSelectorOverrides = {
    [PaymentMethod.Card]: PaymentMethodOverrideKeys.Card,
};
export var PaymentFeeType;
(function (PaymentFeeType) {
    PaymentFeeType["Collection"] = "paymentFeeCollection";
    PaymentFeeType["Fixed"] = "fixed";
})(PaymentFeeType || (PaymentFeeType = {}));
export const ORDER_NUMBER = 'order number';
export const KIOSK_REDIRECT_DELAY = 15000;
